import { render, staticRenderFns } from "./AccettazioneSsnEditViewComponent.vue?vue&type=template&id=4c0cc002&scoped=true"
import script from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnEditViewComponent.vue?vue&type=style&index=0&id=4c0cc002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0cc002",
  null
  
)

export default component.exports